<template>
  <div>
    <div v-if="isTotalDocumentsDisplayed">
      <span class="envelope-stats-text heading-sm-bold">
        {{ $t('project.signing-checklist.SigningChecklistEnvelopeStats.totalDocuments') }}
        <v-chip size="small" variant="flat" class="bg-surface-neutral text-text-neutral ml-2">
          <span class="detail-md-bold">
            {{ totalDocuments }}
          </span>
        </v-chip>
      </span>
    </div>
    <v-skeleton-loader v-else class="envelope-stats-skeleton-loader" type="text,avatar" width="140">
    </v-skeleton-loader>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'SigningChecklistEnvelopeStats',
  computed: {
    ...mapState('signingChecklist', ['totalDocuments']),
    isTotalDocumentsDisplayed (): boolean {
      return typeof this.totalDocuments === 'number'
    },
  },
})
</script>

<style scoped>
/* The skeleton loader adds the different types as different block divs otherwise */
.envelope-stats-skeleton-loader {
    display: flex;
    align-items: center;
    gap: 12px;
}

.envelope-stats-skeleton-loader :deep(.v-skeleton-loader__avatar) {
    width: 24px;
    height: 24px;
}

.envelope-stats-text {
  color: rgb(var(--v-theme-text-primary)) !important;
}
</style>
